import type { MatchData } from "./types";

// ==================================================
// TOURNAMENT INSTANCE IDs
// ==================================================

const SIX_NATIONS_2026 = "six-nations-2026";
const NATIONS_CHAMPIONSHIP_2026 = "nations-championship-2026";
const WORLD_RUGBY_NATIONS_CUP_2026 = "world-rugby-nations-cup-2026";
const INTERNATIONAL_TESTS_2026 = "international-tests-2026";
const PACIFIC_NATIONS_2026 = "pacific-nations-2026";
const BLEDISLOE_2026 = "bledisloe-cup-2026";
const SA_NZ_RIVAL_TOUR_2026 = "sa-nz-rival-tour-2026";

// ==================================================
// MEN'S MATCHES 2026
// ==================================================

export const matches2026Men: MatchData[] = [

  // ==================================================
  // SIX NATIONS 2026 — COMPLETE
  // ==================================================

  {
    id: 1001,
    matchKey: "france-vs-ireland",
    competitionId: "six-nations",
    tournamentInstanceId: SIX_NATIONS_2026,
    tournament: "Six Nations 2026",
    gender: "men",
    round: "Round 1",
    date: "2026-02-05",
    venue: "Stade de France, Paris",
    home: { name: "France", country: "france" },
    away: { name: "Ireland", country: "ireland" },
    score: { home: 27, away: 20 },
    state: "final",
  },
  {
    id: 1002,
    matchKey: "italy-vs-scotland",
    competitionId: "six-nations",
    tournamentInstanceId: SIX_NATIONS_2026,
    tournament: "Six Nations 2026",
    gender: "men",
    round: "Round 1",
    date: "2026-02-06",
    venue: "Stadio Olimpico, Rome",
    home: { name: "Italy", country: "italy" },
    away: { name: "Scotland", country: "scotland" },
    score: { home: 18, away: 24 },
    state: "final",
  },
  {
    id: 1003,
    matchKey: "england-vs-wales",
    competitionId: "six-nations",
    tournamentInstanceId: SIX_NATIONS_2026,
    tournament: "Six Nations 2026",
    gender: "men",
    round: "Round 1",
    date: "2026-02-07",
    venue: "Twickenham, London",
    home: { name: "England", country: "england" },
    away: { name: "Wales", country: "wales" },
    score: { home: 30, away: 22 },
    state: "final",
  },
  {
    id: 1004,
    matchKey: "ireland-vs-italy",
    competitionId: "six-nations",
    tournamentInstanceId: SIX_NATIONS_2026,
    tournament: "Six Nations 2026",
    gender: "men",
    round: "Round 2",
    date: "2026-02-14",
    venue: "Aviva Stadium, Dublin",
    home: { name: "Ireland", country: "ireland" },
    away: { name: "Italy", country: "italy" },
    score: { home: 35, away: 12 },
    state: "final",
  },
  {
    id: 1005,
    matchKey: "wales-vs-france",
    competitionId: "six-nations",
    tournamentInstanceId: SIX_NATIONS_2026,
    tournament: "Six Nations 2026",
    gender: "men",
    round: "Round 2",
    date: "2026-02-15",
    venue: "Principality Stadium, Cardiff",
    home: { name: "Wales", country: "wales" },
    away: { name: "France", country: "france" },
    score: { home: 19, away: 28 },
    state: "final",
  },
  {
    id: 1006,
    matchKey: "scotland-vs-england",
    competitionId: "six-nations",
    tournamentInstanceId: SIX_NATIONS_2026,
    tournament: "Six Nations 2026",
    gender: "men",
    round: "Round 2",
    date: "2026-02-16",
    venue: "Murrayfield, Edinburgh",
    home: { name: "Scotland", country: "scotland" },
    away: { name: "England", country: "england" },
    score: { home: 21, away: 25 },
    state: "final",
  },
  {
    id: 1007,
    matchKey: "italy-vs-wales",
    competitionId: "six-nations",
    tournamentInstanceId: SIX_NATIONS_2026,
    tournament: "Six Nations 2026",
    gender: "men",
    round: "Round 3",
    date: "2026-02-21",
    venue: "Stadio Olimpico, Rome",
    home: { name: "Italy", country: "italy" },
    away: { name: "Wales", country: "wales" },
    score: { home: 17, away: 20 },
    state: "final",
  },
  {
    id: 1008,
    matchKey: "england-vs-france",
    competitionId: "six-nations",
    tournamentInstanceId: SIX_NATIONS_2026,
    tournament: "Six Nations 2026",
    gender: "men",
    round: "Round 3",
    date: "2026-02-22",
    venue: "Twickenham, London",
    home: { name: "England", country: "england" },
    away: { name: "France", country: "france" },
    score: { home: 26, away: 24 },
    state: "final",
  },
  {
    id: 1009,
    matchKey: "ireland-vs-scotland",
    competitionId: "six-nations",
    tournamentInstanceId: SIX_NATIONS_2026,
    tournament: "Six Nations 2026",
    gender: "men",
    round: "Round 3",
    date: "2026-02-23",
    venue: "Aviva Stadium, Dublin",
    home: { name: "Ireland", country: "ireland" },
    away: { name: "Scotland", country: "scotland" },
    score: { home: 29, away: 18 },
    state: "final",
  },
  {
    id: 1010,
    matchKey: "france-vs-italy",
    competitionId: "six-nations",
    tournamentInstanceId: SIX_NATIONS_2026,
    tournament: "Six Nations 2026",
    gender: "men",
    round: "Round 4",
    date: "2026-03-07",
    venue: "Stade de France, Paris",
    home: { name: "France", country: "france" },
    away: { name: "Italy", country: "italy" },
    score: { home: 34, away: 10 },
    state: "final",
  },
  {
    id: 1011,
    matchKey: "scotland-vs-wales",
    competitionId: "six-nations",
    tournamentInstanceId: SIX_NATIONS_2026,
    tournament: "Six Nations 2026",
    gender: "men",
    round: "Round 4",
    date: "2026-03-08",
    venue: "Murrayfield, Edinburgh",
    home: { name: "Scotland", country: "scotland" },
    away: { name: "Wales", country: "wales" },
    score: { home: 23, away: 19 },
    state: "final",
  },
  {
    id: 1012,
    matchKey: "england-vs-ireland",
    competitionId: "six-nations",
    tournamentInstanceId: SIX_NATIONS_2026,
    tournament: "Six Nations 2026",
    gender: "men",
    round: "Round 4",
    date: "2026-03-09",
    venue: "Twickenham, London",
    home: { name: "England", country: "england" },
    away: { name: "Ireland", country: "ireland" },
    score: { home: 27, away: 26 },
    state: "final",
  },
  {
    id: 1013,
    matchKey: "wales-vs-england",
    competitionId: "six-nations",
    tournamentInstanceId: SIX_NATIONS_2026,
    tournament: "Six Nations 2026",
    gender: "men",
    round: "Round 5",
    date: "2026-03-14",
    venue: "Principality Stadium, Cardiff",
    home: { name: "Wales", country: "wales" },
    away: { name: "England", country: "england" },
    score: { home: 20, away: 33 },
    state: "final",
  },
  {
    id: 1014,
    matchKey: "italy-vs-france",
    competitionId: "six-nations",
    tournamentInstanceId: SIX_NATIONS_2026,
    tournament: "Six Nations 2026",
    gender: "men",
    round: "Round 5",
    date: "2026-03-14",
    venue: "Stadio Olimpico, Rome",
    home: { name: "Italy", country: "italy" },
    away: { name: "France", country: "france" },
    score: { home: 16, away: 31 },
    state: "final",
  },
  {
    id: 1015,
    matchKey: "ireland-vs-scotland",
    competitionId: "six-nations",
    tournamentInstanceId: SIX_NATIONS_2026,
    tournament: "Six Nations 2026",
    gender: "men",
    round: "Round 5",
    date: "2026-03-14",
    venue: "Aviva Stadium, Dublin",
    home: { name: "Ireland", country: "ireland" },
    away: { name: "Scotland", country: "scotland" },
    score: { home: 28, away: 17 },
    state: "final",
  },

  // ==================================================
  // INTERNATIONAL TESTS
  // ==================================================

  {
    id: 2997,
    matchKey: "japan-vs-australia",
    competitionId: "international-tests",
    tournamentInstanceId: INTERNATIONAL_TESTS_2026,
    tournament: "Men's International Tests 2026",
    gender: "men",
    round: "Test Match",
    date: "2026-08-08",
    venue: "Hanazono Rugby Stadium, Osaka",
    home: { name: "Japan", country: "japan" },
    away: { name: "Australia", country: "australia" },
    score: { home: 21, away: 38 },
    state: "final",
    startTime: "14:50",
  },
  {
    id: 2998,
    matchKey: "argentina-vs-south-africa",
    competitionId: "international-tests",
    tournamentInstanceId: INTERNATIONAL_TESTS_2026,
    tournament: "Men's International Tests 2026",
    gender: "men",
    round: "Test Match",
    date: "2026-08-08",
    venue: "Estadio José Amalfitani, Buenos Aires",
    home: { name: "Argentina", country: "argentina" },
    away: { name: "South Africa", country: "south-africa" },
    score: { home: 17, away: 38 },
    state: "final",
    startTime: "21:00",
  },
  {
    id: 2999,
    matchKey: "south-africa-vs-barbarians",
    competitionId: "international-tests",
    tournamentInstanceId: INTERNATIONAL_TESTS_2026,
    tournament: "Men's International Tests 2026",
    gender: "men",
    round: "Test Match",
    date: "2026-06-20",
    venue: "Nelson Mandela Bay Stadium, Gqeberha",
    home: { name: "South Africa", country: "south-africa" },
    away: { name: "Barbarians", country: "barbarians" },
    score: { home: 80, away: 31 },
    state: "final",
  },
  {
    id: 3000,
    matchKey: "wales-vs-barbarians",
    competitionId: "international-tests",
    tournamentInstanceId: INTERNATIONAL_TESTS_2026,
    tournament: "Men's International Tests 2026",
    gender: "men",
    round: "Test Match",
    date: "2026-06-26",
    venue: "Principality Stadium, Cardiff",
    home: { name: "Wales", country: "wales" },
    away: { name: "Barbarians", country: "barbarians" },
    score: { home: 33, away: 31 },
    state: "final",
  },
{
  id: 3007,
  matchKey: "australia-vs-japan",
  competitionId: "international-tests",
  tournamentInstanceId: INTERNATIONAL_TESTS_2026,
  tournament: "Men's International Tests 2026",
  gender: "men",
  round: "Test Match",
  date: "2026-08-15",
  venue: "Queensland Country Bank Stadium, Townsville",
  home: { name: "Australia", country: "australia" },
  away: { name: "Japan", country: "japan" },
  score: { home: 56, away: 17 },
  state: "final",
},
{
  id: 3008,
  matchKey: "argentina-vs-australia-test-1",
  competitionId: "international-tests",
  tournamentInstanceId: INTERNATIONAL_TESTS_2026,
  tournament: "Men's International Tests 2026",
  gender: "men",
  round: "Test Match",
  date: "2026-08-29",
  venue: "Estadio 23 de Agosto, Jujuy",
  home: { name: "Argentina", country: "argentina" },
  away: { name: "Australia", country: "australia" },
  score: { home: 21, away: 27 },
  state: "final",
},
  {
    id: 3009,
    matchKey: "argentina-vs-australia-test-2",
    competitionId: "international-tests",
    tournamentInstanceId: INTERNATIONAL_TESTS_2026,
    tournament: "Men's International Tests 2026",
    gender: "men",
    round: "Test Match",
    date: "2026-09-05",
    venue: "Estadio Malvinas Argentinas, Mendoza",
    home: { name: "Argentina", country: "argentina" },
    away: { name: "Australia", country: "australia" },
    score: { home: 28, away: 28 },
  state: "final",
  },

  {
  id: 8001,
  matchKey: "polska-vs-czechy-2026",
  competitionId: "international-tests",
  tournamentInstanceId: INTERNATIONAL_TESTS_2026,
  tournament: "Men's International Tests 2026",
  gender: "men",
  round: "Friendly",
  date: "2026-09-19",
  venue: "Stadion Miejski im. Ojca Władysława Augustynka, Nowy Sącz",
  home: { name: "Polska", country: "poland" },
  away: { name: "Czechy", country: "czech-republic" },
   score: { home: 33, away: 19 },
  state: "final",
  startTime: "20:00",
},

{
  id: 3010,
  matchKey: "australia-vs-south-africa-2026",
  competitionId: "international-tests",
  tournamentInstanceId: INTERNATIONAL_TESTS_2026,
  tournament: "Men's International Tests 2026",
  gender: "men",
  round: "Test Match",
  date: "2026-09-27",
  venue: "Optus Stadium, Perth",
  home: { name: "Australia", country: "australia" },
  away: { name: "South Africa", country: "south-africa" },
  score: { home: 42, away: 38 },
  state: "final",
  startTime: "11:45",
},

{
  id: 3011,
  matchKey: "japan-vs-fiji-2026",
  competitionId: "international-tests",
  tournamentInstanceId: INTERNATIONAL_TESTS_2026,
  tournament: "Men's International Tests 2026",
  gender: "men",
  round: "Test Match",
  date: "2026-10-24",
  venue: "Prince Chichibu Memorial Stadium, Tokyo",
  home: { name: "Japan", country: "japan" },
  away: { name: "Fiji", country: "fiji" },
  score: { home: 28, away: 34 },
  state: "final",
  startTime: "14:50",
},

  // ==================================================
  // NATIONS CHAMPIONSHIP 2026
  // ==================================================

  // ----- ROUND 1 (FINAL) -----
  {
    id: 3001,
    matchKey: "south-africa-vs-england",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 1",
    date: "2026-07-04",
    venue: "Ellis Park, Johannesburg",
    home: { name: "South Africa", country: "south-africa" },
    away: { name: "England", country: "england" },
    score: { home: 45, away: 21 },
    state: "final",
  },
  {
    id: 3002,
    matchKey: "new-zealand-vs-france",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 1",
    date: "2026-07-04",
    venue: "One New Zealand Stadium, Christchurch",
    home: { name: "New Zealand", country: "new-zealand" },
    away: { name: "France", country: "france" },
    score: { home: 34, away: 32 },
    state: "final",
  },
  {
    id: 3003,
    matchKey: "australia-vs-ireland",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 1",
    date: "2026-07-04",
    venue: "Sydney Football Stadium, Sydney",
    home: { name: "Australia", country: "australia" },
    away: { name: "Ireland", country: "ireland" },
    score: { home: 31, away: 33 },
    state: "final",
  },
  {
    id: 3004,
    matchKey: "japan-vs-italy",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 1",
    date: "2026-07-04",
    venue: "Prince Chichibu Memorial Stadium, Tokyo",
    home: { name: "Japan", country: "japan" },
    away: { name: "Italy", country: "italy" },
    score: { home: 27, away: 10 },
    state: "final",
  },
  {
    id: 3005,
    matchKey: "fiji-vs-wales",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 1",
    date: "2026-07-04",
    venue: "Cardiff City Stadium, Cardiff",
    home: { name: "Fiji", country: "fiji" },
    away: { name: "Wales", country: "wales" },
    score: { home: 24, away: 39 },
    state: "final",
  },
  {
    id: 3006,
    matchKey: "argentina-vs-scotland",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 1",
    date: "2026-07-04",
    venue: "Estadio Mario Alberto Kempes, Cordoba",
    home: { name: "Argentina", country: "argentina" },
    away: { name: "Scotland", country: "scotland" },
    score: { home: 38, away: 47 },
    state: "final",
  },

  // ----- ROUND 2 (FINAL) -----
  {
    id: 3011,
    matchKey: "new-zealand-vs-italy",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 2",
    date: "2026-07-11",
    venue: "Wellington Regional Stadium, Wellington",
    home: { name: "New Zealand", country: "new-zealand" },
    away: { name: "Italy", country: "italy" },
    score: { home: 47, away: 17 },
    state: "final",
  },
  {
    id: 3011,
    matchKey: "australia-vs-france",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 2",
    date: "2026-07-11",
    venue: "Suncorp Stadium, Brisbane",
    home: { name: "Australia", country: "australia" },
    away: { name: "France", country: "france" },
    score: { home: 26, away: 42 },
    state: "final",
  },
  {
    id: 3012,
    matchKey: "japan-vs-ireland",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 2",
    date: "2026-07-11",
    venue: "McDonald Jones Stadium, Newcastle",
    home: { name: "Japan", country: "japan" },
    away: { name: "Ireland", country: "ireland" },
    score: { home: 20, away: 29 },
    state: "final",
  },
  {
    id: 3013,
    matchKey: "fiji-vs-england",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 2",
    date: "2026-07-11",
    venue: "Hill Dickinson Stadium, Liverpool",
    home: { name: "Fiji", country: "fiji" },
    away: { name: "England", country: "england" },
    score: { home: 8, away: 73 },
    state: "final",
  },
  {
    id: 3014,
    matchKey: "south-africa-vs-scotland",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 2",
    date: "2026-07-11",
    venue: "Loftus Versfeld, Pretoria",
    home: { name: "South Africa", country: "south-africa" },
    away: { name: "Scotland", country: "scotland" },
    score: { home: 42, away: 28 },
    state: "final",
  },
  {
    id: 3015,
    matchKey: "argentina-vs-wales",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 2",
    date: "2026-07-11",
    venue: "Estadio San Juan del Bicentenario, San Juan",
    home: { name: "Argentina", country: "argentina" },
    away: { name: "Wales", country: "wales" },
    score: { home: 35, away: 21 },
    state: "final",
  },

  // ----- ROUND 3 (FINAL) -----
  {
    id: 3020,
    matchKey: "japan-vs-france",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 3",
    date: "2026-07-18",
    venue: "MUFG Stadium, Tokyo",
    home: { name: "Japan", country: "japan" },
    away: { name: "France", country: "france" },
    score: { home: 15, away: 42 },
    state: "final",
  },
  {
    id: 3021,
    matchKey: "new-zealand-vs-ireland",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 3",
    date: "2026-07-18",
    venue: "Eden Park, Auckland",
    home: { name: "New Zealand", country: "new-zealand" },
    away: { name: "Ireland", country: "ireland" },
    score: { home: 40, away: 21 },
    state: "final",
  },
  {
    id: 3022,
    matchKey: "australia-vs-italy",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 3",
    date: "2026-07-18",
    venue: "HBF Park, Perth",
    home: { name: "Australia", country: "australia" },
    away: { name: "Italy", country: "italy" },
    score: { home: 57, away: 10 },
    state: "final",
  },
  {
    id: 3023,
    matchKey: "fiji-vs-scotland",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 3",
    date: "2026-07-18",
    venue: "Murrayfield, Edinburgh",
    home: { name: "Fiji", country: "fiji" },
    away: { name: "Scotland", country: "scotland" },
    score: { home: 17, away: 33 },
    state: "final",
  },
  {
    id: 3024,
    matchKey: "south-africa-vs-wales",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 3",
    date: "2026-07-18",
    venue: "Hollywoodbets Kings Park, Durban",
    home: { name: "South Africa", country: "south-africa" },
    away: { name: "Wales", country: "wales" },
    score: { home: 43, away: 0 },
    state: "final",
  },
  {
    id: 3025,
    matchKey: "argentina-vs-england",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 3",
    date: "2026-07-18",
    venue: "Estadio Único Madre de Ciudades, Santiago del Estero",
    home: { name: "Argentina", country: "argentina" },
    away: { name: "England", country: "england" },
    score: { home: 24, away: 31 },
    state: "final",
  },

  // ----- ROUND 4 (UPCOMING) -----
  {
    id: 3030,
    matchKey: "ireland-vs-argentina",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 4",
    date: "2026-11-07",
    venue: "Aviva Stadium, Dublin",
    home: { name: "Ireland", country: "ireland" },
    away: { name: "Argentina", country: "argentina" },
    state: "upcoming",
    startTime: "TBD",
  },
  {
    id: 3031,
    matchKey: "italy-vs-south-africa",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 4",
    date: "2026-11-07",
    venue: "Juventus Stadium, Turin",
    home: { name: "Italy", country: "italy" },
    away: { name: "South Africa", country: "south-africa" },
    state: "upcoming",
    startTime: "TBD",
  },
  {
    id: 3032,
    matchKey: "scotland-vs-new-zealand",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 4",
    date: "2026-11-07",
    venue: "Murrayfield, Edinburgh",
    home: { name: "Scotland", country: "scotland" },
    away: { name: "New Zealand", country: "new-zealand" },
    state: "upcoming",
    startTime: "TBD",
  },
  {
    id: 3033,
    matchKey: "wales-vs-japan",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 4",
    date: "2026-11-07",
    venue: "Principality Stadium, Cardiff",
    home: { name: "Wales", country: "wales" },
    away: { name: "Japan", country: "japan" },
    state: "upcoming",
    startTime: "TBD",
  },
  {
    id: 3034,
    matchKey: "france-vs-fiji",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 4",
    date: "2026-11-07",
    venue: "Groupama Stadium, Lyon",
    home: { name: "France", country: "france" },
    away: { name: "Fiji", country: "fiji" },
    state: "upcoming",
    startTime: "TBD",
  },
  {
    id: 3035,
    matchKey: "england-vs-australia",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 4",
    date: "2026-11-07",
    venue: "Twickenham, London",
    home: { name: "England", country: "england" },
    away: { name: "Australia", country: "australia" },
    state: "upcoming",
    startTime: "TBD",
  },

  // ----- ROUND 5 (UPCOMING) -----
  {
    id: 3040,
    matchKey: "france-vs-south-africa",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 5",
    date: "2026-11-14",
    venue: "Stade de France, Paris",
    home: { name: "France", country: "france" },
    away: { name: "South Africa", country: "south-africa" },
    state: "upcoming",
    startTime: "TBD",
  },
  {
    id: 3041,
    matchKey: "italy-vs-argentina",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 5",
    date: "2026-11-14",
    venue: "Stadio Luigi Ferraris, Genoa",
    home: { name: "Italy", country: "italy" },
    away: { name: "Argentina", country: "argentina" },
    state: "upcoming",
    startTime: "TBD",
  },
  {
    id: 3042,
    matchKey: "wales-vs-new-zealand",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 5",
    date: "2026-11-14",
    venue: "Principality Stadium, Cardiff",
    home: { name: "Wales", country: "wales" },
    away: { name: "New Zealand", country: "new-zealand" },
    state: "upcoming",
    startTime: "TBD",
  },
  {
    id: 3043,
    matchKey: "england-vs-japan",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 5",
    date: "2026-11-14",
    venue: "Twickenham, London",
    home: { name: "England", country: "england" },
    away: { name: "Japan", country: "japan" },
    state: "upcoming",
    startTime: "TBD",
  },
  {
    id: 3044,
    matchKey: "ireland-vs-fiji",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 5",
    date: "2026-11-14",
    venue: "Aviva Stadium, Dublin",
    home: { name: "Ireland", country: "ireland" },
    away: { name: "Fiji", country: "fiji" },
    state: "upcoming",
    startTime: "TBD",
  },
  {
    id: 3045,
    matchKey: "scotland-vs-australia",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 5",
    date: "2026-11-14",
    venue: "Murrayfield, Edinburgh",
    home: { name: "Scotland", country: "scotland" },
    away: { name: "Australia", country: "australia" },
    state: "upcoming",
    startTime: "TBD",
  },

  // ----- ROUND 6 (UPCOMING) -----
  {
    id: 3050,
    matchKey: "england-vs-new-zealand",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 6",
    date: "2026-11-21",
    venue: "Twickenham, London",
    home: { name: "England", country: "england" },
    away: { name: "New Zealand", country: "new-zealand" },
    state: "upcoming",
    startTime: "TBD",
  },
  {
    id: 3051,
    matchKey: "scotland-vs-japan",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 6",
    date: "2026-11-21",
    venue: "Murrayfield, Edinburgh",
    home: { name: "Scotland", country: "scotland" },
    away: { name: "Japan", country: "japan" },
    state: "upcoming",
    startTime: "TBD",
  },
  {
    id: 3052,
    matchKey: "ireland-vs-south-africa",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 6",
    date: "2026-11-21",
    venue: "Aviva Stadium, Dublin",
    home: { name: "Ireland", country: "ireland" },
    away: { name: "South Africa", country: "south-africa" },
    state: "upcoming",
    startTime: "TBD",
  },
  {
    id: 3053,
    matchKey: "italy-vs-fiji",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 6",
    date: "2026-11-21",
    venue: "Stadio Friuli, Udine",
    home: { name: "Italy", country: "italy" },
    away: { name: "Fiji", country: "fiji" },
    state: "upcoming",
    startTime: "TBD",
  },
  {
    id: 3054,
    matchKey: "wales-vs-australia",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 6",
    date: "2026-11-21",
    venue: "Principality Stadium, Cardiff",
    home: { name: "Wales", country: "wales" },
    away: { name: "Australia", country: "australia" },
    state: "upcoming",
    startTime: "TBD",
  },
  {
    id: 3055,
    matchKey: "france-vs-argentina",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    round: "Round 6",
    date: "2026-11-21",
    venue: "Stade de France, Paris",
    home: { name: "France", country: "france" },
    away: { name: "Argentina", country: "argentina" },
    state: "upcoming",
    startTime: "TBD",
  },

  // ----- FINALS WEEKEND (UPCOMING) -----
  {
    id: 3060,
    matchKey: "11th-place-playoff",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    stage: "Knockout",
    round: "11th Place Playoff",
    date: "2026-11-27",
    venue: "Twickenham, London",
    home: { name: "TBD", country: "unknown" },
    away: { name: "TBD", country: "unknown" },
    state: "upcoming",
    placement: 11,
    startTime: "TBD",
  },
  {
    id: 3061,
    matchKey: "9th-place-playoff",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    stage: "Knockout",
    round: "9th Place Playoff",
    date: "2026-11-27",
    venue: "Twickenham, London",
    home: { name: "TBD", country: "unknown" },
    away: { name: "TBD", country: "unknown" },
    state: "upcoming",
    placement: 9,
    startTime: "TBD",
  },
  {
    id: 3062,
    matchKey: "7th-place-playoff",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    stage: "Knockout",
    round: "7th Place Playoff",
    date: "2026-11-28",
    venue: "Twickenham, London",
    home: { name: "TBD", country: "unknown" },
    away: { name: "TBD", country: "unknown" },
    state: "upcoming",
    placement: 7,
    startTime: "TBD",
  },
  {
    id: 3063,
    matchKey: "5th-place-playoff",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    stage: "Knockout",
    round: "5th Place Playoff",
    date: "2026-11-28",
    venue: "Twickenham, London",
    home: { name: "TBD", country: "unknown" },
    away: { name: "TBD", country: "unknown" },
    state: "upcoming",
    placement: 5,
    startTime: "TBD",
  },
  {
    id: 3064,
    matchKey: "third-place-playoff",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    stage: "Knockout",
    round: "3rd Place Playoff",
    date: "2026-11-29",
    venue: "Twickenham, London",
    home: { name: "TBD", country: "unknown" },
    away: { name: "TBD", country: "unknown" },
    state: "upcoming",
    placement: 3,
    startTime: "TBD",
  },
  {
    id: 3065,
    matchKey: "championship-final",
    competitionId: "nations-championship",
    tournamentInstanceId: NATIONS_CHAMPIONSHIP_2026,
    tournament: "Nations Championship 2026",
    gender: "men",
    stage: "Knockout",
    round: "Championship Final",
    date: "2026-11-29",
    venue: "Twickenham, London",
    home: { name: "TBD", country: "unknown" },
    away: { name: "TBD", country: "unknown" },
    state: "upcoming",
    placement: 1,
    startTime: "TBD",
  },

  // ==================================================
  // WORLD RUGBY NATIONS CUP 2026 — COMPLETE
  // ==================================================

  // ----- ROUND 1 (FINAL) -----
  {
    id: 3501,
    matchKey: "uruguay-vs-georgia",
    competitionId: "world-rugby-nations-cup",
    tournamentInstanceId: WORLD_RUGBY_NATIONS_CUP_2026,
    tournament: "World Rugby Nations Cup 2026",
    gender: "men",
    stage: "Pool",
    round: "Round 1",
    date: "2026-07-04",
    venue: "Estadio Charrúa, Montevideo",
    home: { name: "Uruguay", country: "uruguay" },
    away: { name: "Georgia", country: "georgia" },
    score: { home: 34, away: 41 },
    state: "final",
  },
  {
    id: 3502,
    matchKey: "samoa-vs-hong-kong-china",
    competitionId: "world-rugby-nations-cup",
    tournamentInstanceId: WORLD_RUGBY_NATIONS_CUP_2026,
    tournament: "World Rugby Nations Cup 2026",
    gender: "men",
    stage: "Pool",
    round: "Round 1",
    date: "2026-07-04",
    venue: "Estadio Nacional, Santiago",
    home: { name: "Samoa", country: "samoa" },
    away: { name: "Hong Kong China", country: "hong-kong-china" },
    score: { home: 66, away: 19 },
    state: "final",
  },
  {
    id: 3503,
    matchKey: "chile-vs-romania",
    competitionId: "world-rugby-nations-cup",
    tournamentInstanceId: WORLD_RUGBY_NATIONS_CUP_2026,
    tournament: "World Rugby Nations Cup 2026",
    gender: "men",
    stage: "Pool",
    round: "Round 1",
    date: "2026-07-04",
    venue: "Estadio Nacional, Santiago",
    home: { name: "Chile", country: "chile" },
    away: { name: "Romania", country: "romania" },
    score: { home: 48, away: 31 },
    state: "final",
  },
  {
    id: 3504,
    matchKey: "tonga-vs-zimbabwe",
    competitionId: "world-rugby-nations-cup",
    tournamentInstanceId: WORLD_RUGBY_NATIONS_CUP_2026,
    tournament: "World Rugby Nations Cup 2026",
    gender: "men",
    stage: "Pool",
    round: "Round 1",
    date: "2026-07-04",
    venue: "Dick's Sporting Goods Park, Denver",
    home: { name: "Tonga", country: "tonga" },
    away: { name: "Zimbabwe", country: "zimbabwe" },
    score: { home: 36, away: 26 },
    state: "final",
  },
  {
    id: 3505,
    matchKey: "usa-vs-portugal",
    competitionId: "world-rugby-nations-cup",
    tournamentInstanceId: WORLD_RUGBY_NATIONS_CUP_2026,
    tournament: "World Rugby Nations Cup 2026",
    gender: "men",
    stage: "Pool",
    round: "Round 1",
    date: "2026-07-04",
    venue: "Dick's Sporting Goods Park, Denver",
    home: { name: "USA", country: "united-states-of-america" },
    away: { name: "Portugal", country: "portugal" },
    score: { home: 30, away: 29 },
    state: "final",
  },
  {
    id: 3506,
    matchKey: "spain-vs-canada",
    competitionId: "world-rugby-nations-cup",
    tournamentInstanceId: WORLD_RUGBY_NATIONS_CUP_2026,
    tournament: "World Rugby Nations Cup 2026",
    gender: "men",
    stage: "Pool",
    round: "Round 1",
    date: "2026-07-04",
    venue: "TBD",
    home: { name: "Spain", country: "spain" },
    away: { name: "Canada", country: "canada" },
    score: { home: 21, away: 14 },
    state: "final",
  },

  // ----- ROUND 2 (FINAL) -----
  {
    id: 3510,
    matchKey: "uruguay-vs-romania",
    competitionId: "world-rugby-nations-cup",
    tournamentInstanceId: WORLD_RUGBY_NATIONS_CUP_2026,
    tournament: "World Rugby Nations Cup 2026",
    gender: "men",
    stage: "Pool",
    round: "Round 2",
    date: "2026-07-11",
    venue: "Estadio Charrúa, Montevideo",
    home: { name: "Uruguay", country: "uruguay" },
    away: { name: "Romania", country: "romania" },
    score: { home: 36, away: 36 },
    state: "final",
  },
  {
    id: 3511,
    matchKey: "chile-vs-hong-kong-china",
    competitionId: "world-rugby-nations-cup",
    tournamentInstanceId: WORLD_RUGBY_NATIONS_CUP_2026,
    tournament: "World Rugby Nations Cup 2026",
    gender: "men",
    stage: "Pool",
    round: "Round 2",
    date: "2026-07-11",
    venue: "Estadio Sausalito, Viña del Mar",
    home: { name: "Chile", country: "chile" },
    away: { name: "Hong Kong China", country: "hong-kong-china" },
    score: { home: 38, away: 17 },
    state: "final",
  },
  {
    id: 3512,
    matchKey: "canada-vs-portugal",
    competitionId: "world-rugby-nations-cup",
    tournamentInstanceId: WORLD_RUGBY_NATIONS_CUP_2026,
    tournament: "World Rugby Nations Cup 2026",
    gender: "men",
    stage: "Pool",
    round: "Round 2",
    date: "2026-07-11",
    venue: "Clarke Stadium, Edmonton",
    home: { name: "Canada", country: "canada" },
    away: { name: "Portugal", country: "portugal" },
    score: { home: 14, away: 38 },
    state: "final",
  },
  {
    id: 3513,
    matchKey: "tonga-vs-spain",
    competitionId: "world-rugby-nations-cup",
    tournamentInstanceId: WORLD_RUGBY_NATIONS_CUP_2026,
    tournament: "World Rugby Nations Cup 2026",
    gender: "men",
    stage: "Pool",
    round: "Round 2",
    date: "2026-07-11",
    venue: "Clarke Stadium, Edmonton",
    home: { name: "Tonga", country: "tonga" },
    away: { name: "Spain", country: "spain" },
    score: { home: 19, away: 32 },
    state: "final",
  },
  {
    id: 3514,
    matchKey: "samoa-vs-georgia",
    competitionId: "world-rugby-nations-cup",
    tournamentInstanceId: WORLD_RUGBY_NATIONS_CUP_2026,
    tournament: "World Rugby Nations Cup 2026",
    gender: "men",
    stage: "Pool",
    round: "Round 2",
    date: "2026-07-11",
    venue: "Estadio Sausalito, Viña del Mar",
    home: { name: "Samoa", country: "samoa" },
    away: { name: "Georgia", country: "georgia" },
    score: { home: 12, away: 33 },
    state: "final",
  },
  {
    id: 3515,
    matchKey: "usa-vs-zimbabwe",
    competitionId: "world-rugby-nations-cup",
    tournamentInstanceId: WORLD_RUGBY_NATIONS_CUP_2026,
    tournament: "World Rugby Nations Cup 2026",
    gender: "men",
    stage: "Pool",
    round: "Round 2",
    date: "2026-07-11",
    venue: "American Legion Memorial Stadium, Charlotte",
    home: { name: "USA", country: "united-states-of-america" },
    away: { name: "Zimbabwe", country: "zimbabwe" },
    score: { home: 31, away: 15 },
    state: "final",
  },

  // ----- ROUND 3 (FINAL) -----
  {
    id: 3520,
    matchKey: "samoa-vs-romania",
    competitionId: "world-rugby-nations-cup",
    tournamentInstanceId: WORLD_RUGBY_NATIONS_CUP_2026,
    tournament: "World Rugby Nations Cup 2026",
    gender: "men",
    stage: "Pool",
    round: "Round 3",
    date: "2026-07-18",
    venue: "Estadio Charrúa, Montevideo",
    home: { name: "Samoa", country: "samoa" },
    away: { name: "Romania", country: "romania" },
    score: { home: 37, away: 38 },
    state: "final",
  },
  {
    id: 3521,
    matchKey: "uruguay-vs-hong-kong-china",
    competitionId: "world-rugby-nations-cup",
    tournamentInstanceId: WORLD_RUGBY_NATIONS_CUP_2026,
    tournament: "World Rugby Nations Cup 2026",
    gender: "men",
    stage: "Pool",
    round: "Round 3",
    date: "2026-07-18",
    venue: "Estadio Charrúa, Montevideo",
    home: { name: "Uruguay", country: "uruguay" },
    away: { name: "Hong Kong China", country: "hong-kong-china" },
    score: { home: 40, away: 42 },
    state: "final",
  },
  {
    id: 3522,
    matchKey: "tonga-vs-portugal",
    competitionId: "world-rugby-nations-cup",
    tournamentInstanceId: WORLD_RUGBY_NATIONS_CUP_2026,
    tournament: "World Rugby Nations Cup 2026",
    gender: "men",
    stage: "Pool",
    round: "Round 3",
    date: "2026-07-18",
    venue: "Princess Auto Stadium, Winnipeg",
    home: { name: "Tonga", country: "tonga" },
    away: { name: "Portugal", country: "portugal" },
    score: { home: 28, away: 32 },
    state: "final",
  },
  {
    id: 3523,
    matchKey: "chile-vs-georgia",
    competitionId: "world-rugby-nations-cup",
    tournamentInstanceId: WORLD_RUGBY_NATIONS_CUP_2026,
    tournament: "World Rugby Nations Cup 2026",
    gender: "men",
    stage: "Pool",
    round: "Round 3",
    date: "2026-07-18",
    venue: "Estadio La Portada, La Serena",
    home: { name: "Chile", country: "chile" },
    away: { name: "Georgia", country: "georgia" },
    score: { home: 22, away: 49 },
    state: "final",
  },
  {
    id: 3524,
    matchKey: "usa-vs-spain",
    competitionId: "world-rugby-nations-cup",
    tournamentInstanceId: WORLD_RUGBY_NATIONS_CUP_2026,
    tournament: "World Rugby Nations Cup 2026",
    gender: "men",
    stage: "Pool",
    round: "Round 3",
    date: "2026-07-18",
    venue: "WakeMed Soccer Park, Cary",
    home: { name: "USA", country: "united-states-of-america" },
    away: { name: "Spain", country: "spain" },
    score: { home: 29, away: 22 },
    state: "final",
  },
  {
    id: 3525,
    matchKey: "canada-vs-zimbabwe",
    competitionId: "world-rugby-nations-cup",
    tournamentInstanceId: WORLD_RUGBY_NATIONS_CUP_2026,
    tournament: "World Rugby Nations Cup 2026",
    gender: "men",
    stage: "Pool",
    round: "Round 3",
    date: "2026-07-18",
    venue: "Princess Auto Stadium, Winnipeg",
    home: { name: "Canada", country: "canada" },
    away: { name: "Zimbabwe", country: "zimbabwe" },
    score: { home: 42, away: 26 },
    state: "final",
  },

  // ==================================================
  // PACIFIC NATIONS CUP 2026
  // ==================================================

  {
    id: 5001,
    matchKey: "fiji-vs-canada",
    competitionId: "pacific-nations",
    tournamentInstanceId: PACIFIC_NATIONS_2026,
    tournament: "Pacific Nations Cup 2026",
    gender: "men",
    stage: "Knockout",
    round: "Semi Final",
    date: "2026-09-12",
    venue: "Hanazono Rugby Stadium, Osaka",
    home: { name: "Fiji", country: "fiji" },
    away: { name: "Canada", country: "canada" },
    score: { home: 45, away: 29 },
    state: "final",
  },
  {
    id: 5002,
    matchKey: "japan-vs-usa",
    competitionId: "pacific-nations",
    tournamentInstanceId: PACIFIC_NATIONS_2026,
    tournament: "Pacific Nations Cup 2026",
    gender: "men",
    stage: "Knockout",
    round: "Semi Final",
    date: "2026-09-12",
    venue: "Hanazono Rugby Stadium, Osaka",
    home: { name: "Japan", country: "japan" },
    away: { name: "USA", country: "united-states-of-america" },
score: { home: 63, away: 14 },
    state: "final",
  },
 {
  id: 5003,
  matchKey: "pacific-nations-final",
  competitionId: "pacific-nations",
  tournamentInstanceId: PACIFIC_NATIONS_2026,
  tournament: "Pacific Nations Cup 2026",
  gender: "men",
  stage: "Knockout",
  round: "Final",
  date: "2026-09-19",
  venue: "Prince Chichibu Memorial Stadium, Tokyo",
  home: { name: "Fiji", country: "fiji" },
  away: { name: "Japan", country: "japan" },
  score: { home: 15, away: 20 },
  state: "final",
  startTime: "12:05",
},
  {
  id: 5004,
  matchKey: "pacific-nations-third-place",
  competitionId: "pacific-nations",
  tournamentInstanceId: PACIFIC_NATIONS_2026,
  tournament: "Pacific Nations Cup 2026",
  gender: "men",
  stage: "Knockout",
  round: "3rd Place Playoff",
  date: "2026-09-19",
  venue: "Prince Chichibu Memorial Stadium, Tokyo",
  home: { name: "Canada", country: "canada" },
  away: { name: "USA", country: "united-states-of-america" },
  score: { home: 19, away: 16 },
  state: "final",
  startTime: "09:00",
},
  // ==================================================
  // BLEDISLOE CUP 2026
  // ==================================================

{
  id: 6001,
  matchKey: "new-zealand-vs-australia-test-1",
  competitionId: "bledisloe-cup",
  tournamentInstanceId: BLEDISLOE_2026,
  tournament: "Bledisloe Cup 2026",
  gender: "men",
  round: "Test 1",
  date: "2026-10-10",
  venue: "Eden Park, Auckland",
  home: { name: "New Zealand", country: "new-zealand" },
  away: { name: "Australia", country: "australia" },
  score: { home: 50, away: 19 },
  state: "final",
  startTime: "19:10",
},
{
  id: 6002,
  matchKey: "australia-vs-new-zealand-test-2",
  competitionId: "bledisloe-cup",
  tournamentInstanceId: BLEDISLOE_2026,
  tournament: "Bledisloe Cup 2026",
  gender: "men",
  round: "Test 2",
  date: "2026-10-17",
  venue: "Accor Stadium, Sydney",
  home: { name: "Australia", country: "australia" },
  away: { name: "New Zealand", country: "new-zealand" },
  score: { home: 21, away: 43 },
  state: "final",
  startTime: "06:45",
},

  // ==================================================
  // THE RIVALRY TOUR 2026
  // ==================================================

  // ----- MIDWEEK TOUR MATCHES (vs URC TEAMS) -----
  {
    id: 7001,
    matchKey: "stormers-vs-new-zealand",
    competitionId: "sa-nz-rival-tour",
    tournamentInstanceId: SA_NZ_RIVAL_TOUR_2026,
    tournament: "The Rivalry Tour 2026",
    gender: "men",
    round: "Midweek Tour",
    date: "2026-08-07",
    venue: "Cape Town Stadium, Cape Town",
    home: { name: "Stormers", country: "stormers" },
    away: { name: "New Zealand", country: "new-zealand" },
    score: { home: 21, away: 38 },
    state: "final",
  },
  {
    id: 7002,
    matchKey: "sharks-vs-new-zealand",
    competitionId: "sa-nz-rival-tour",
    tournamentInstanceId: SA_NZ_RIVAL_TOUR_2026,
    tournament: "The Rivalry Tour 2026",
    gender: "men",
    round: "Midweek Tour",
    date: "2026-08-11",
    venue: "Kings Park, Durban",
    home: { name: "Sharks", country: "sharks" },
    away: { name: "New Zealand", country: "new-zealand" },
    score: { home: 0, away: 54 },
    state: "final",
  },
  {
    id: 7003,
    matchKey: "bulls-vs-new-zealand",
    competitionId: "sa-nz-rival-tour",
    tournamentInstanceId: SA_NZ_RIVAL_TOUR_2026,
    tournament: "The Rivalry Tour 2026",
    gender: "men",
    round: "Midweek Tour",
    date: "2026-08-15",
    venue: "Loftus Versfeld, Pretoria",
    home: { name: "Bulls", country: "bulls" },
    away: { name: "New Zealand", country: "new-zealand" },
    score: { home: 19, away: 50 },
    state: "final",
    startTime: "19:00",
  },
  {
    id: 7004,
    matchKey: "lions-vs-new-zealand",
    competitionId: "sa-nz-rival-tour",
    tournamentInstanceId: SA_NZ_RIVAL_TOUR_2026,
    tournament: "The Rivalry Tour 2026",
    gender: "men",
    round: "Midweek Tour",
    date: "2026-08-25",
    venue: "Ellis Park, Johannesburg",
    home: { name: "Lions", country: "lions" },
    away: { name: "New Zealand", country: "new-zealand" },
    score: { home: 35, away: 41 },
    state: "final",
    startTime: "19:00",
  },

  // ----- TEST SERIES: "RUGBY'S GREATEST RIVALRY" -----
{
  id: 7005,
  matchKey: "south-africa-vs-new-zealand-test-1",
  competitionId: "sa-nz-rival-tour",
  tournamentInstanceId: SA_NZ_RIVAL_TOUR_2026,
  tournament: "The Rivalry Tour 2026",
  gender: "men",
  round: "1st Test",
  date: "2026-08-22",
  venue: "Ellis Park, Johannesburg",
  home: { name: "South Africa", country: "south-africa" },
  away: { name: "New Zealand", country: "new-zealand" },
  score: { home: 16, away: 33 },
  state: "final",
  startTime: "17:10",
},
 {
  id: 7006,
  matchKey: "south-africa-vs-new-zealand-test-2",
  competitionId: "sa-nz-rival-tour",
  tournamentInstanceId: SA_NZ_RIVAL_TOUR_2026,
  tournament: "The Rivalry Tour 2026",
  gender: "men",
  round: "2nd Test",
  date: "2026-08-29",
  venue: "DHL Stadium, Cape Town",
  home: { name: "South Africa", country: "south-africa" },
  away: { name: "New Zealand", country: "new-zealand" },
  score: { home: 33, away: 26 },
  state: "final",
  startTime: "17:10",
},
  {
    id: 7007,
    matchKey: "south-africa-vs-new-zealand-test-3",
    competitionId: "sa-nz-rival-tour",
    tournamentInstanceId: SA_NZ_RIVAL_TOUR_2026,
    tournament: "The Rivalry Tour 2026",
    gender: "men",
    round: "3rd Test",
    date: "2026-09-05",
    venue: "FNB Stadium, Johannesburg",
    home: { name: "South Africa", country: "south-africa" },
    away: { name: "New Zealand", country: "new-zealand" },
    score: { home: 29, away: 24 },
    state: "final",
    startTime: "17:10",
  },
  {
    id: 7008,
    matchKey: "south-africa-vs-new-zealand-test-4",
    competitionId: "sa-nz-rival-tour",
    tournamentInstanceId: SA_NZ_RIVAL_TOUR_2026,
    tournament: "The Rivalry Tour 2026",
    gender: "men",
    round: "4th Test (Neutral Venue)",
    date: "2026-09-12",
    venue: "M&T Bank Stadium, Baltimore",
    home: { name: "South Africa", country: "south-africa" },
    away: { name: "New Zealand", country: "new-zealand" },
    score: { home: 43, away: 28 },
    state: "final",
  },
];